export const DeleteIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5.5H3H19"
      stroke="#DC2626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 5.5V3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5H12C12.5304 1.5 13.0391 1.71071 13.4142 2.08579C13.7893 2.46086 14 2.96957 14 3.5V5.5M17 5.5V19.5C17 20.0304 16.7893 20.5391 16.4142 20.9142C16.0391 21.2893 15.5304 21.5 15 21.5H5C4.46957 21.5 3.96086 21.2893 3.58579 20.9142C3.21071 20.5391 3 20.0304 3 19.5V5.5H17Z"
      stroke="#DC2626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.5V16.5"
      stroke="#DC2626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 10.5V16.5"
      stroke="#DC2626"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const EditIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 19.0604H19"
      stroke="#5C73DB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 2.56065C14.8978 2.16283 15.4374 1.93933 16 1.93933C16.2786 1.93933 16.5544 1.9942 16.8118 2.10081C17.0692 2.20741 17.303 2.36367 17.5 2.56065C17.697 2.75763 17.8532 2.99149 17.9598 3.24886C18.0665 3.50623 18.1213 3.78208 18.1213 4.06065C18.1213 4.33923 18.0665 4.61508 17.9598 4.87245C17.8532 5.12982 17.697 5.36367 17.5 5.56065L5 18.0607L1 19.0607L2 15.0607L14.5 2.56065Z"
      stroke="#5C73DB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1V11"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 6H11"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AddStepButton = () => (
  <svg
    width="26"
    height="26"
    className="cursor"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.285714"
      y="0.285653"
      width="15.4286"
      height="15.4286"
      rx="7.71429"
      fill="#FFFDF9"
    />
    <g clip-path="url(#clip0_869_5648)">
      <path
        d="M8.61937 12.3333V8.61901H12.3337V7.38091H8.61937V3.66663H7.38128V7.38091H3.66699V8.61901H7.38128V12.3333H8.61937Z"
        fill="#2D2E2E"
      />
    </g>
    <rect
      x="0.285714"
      y="0.285653"
      width="15.4286"
      height="15.4286"
      rx="7.71429"
      stroke="#CCCCCC"
      strokeWidth="0.571429"
    />
    <defs>
      <clipPath id="clip0_869_5648">
        <rect
          width="14.8571"
          height="14.8571"
          fill="white"
          transform="translate(0.571289 0.571381)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const CalanderIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 11H9V13H7V11ZM21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H6V1H8V3H16V1H18V3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5ZM5 7H19V5H5V7ZM19 19V9H5V19H19ZM15 13V11H17V13H15ZM11 13V11H13V13H11ZM7 15H9V17H7V15ZM15 17V15H17V17H15ZM11 17V15H13V17H11Z"
      fill="#64748B"
    />
  </svg>
);
export const QuestIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00018 11.1818C10.2052 11.1818 11.182 10.205 11.182 8.99999C11.182 7.79501 10.2052 6.81818 9.00018 6.81818C7.79519 6.81818 6.81836 7.79501 6.81836 8.99999C6.81836 10.205 7.79519 11.1818 9.00018 11.1818Z"
      stroke="#78633A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3818 11.1818C14.285 11.4012 14.2561 11.6445 14.2989 11.8804C14.3417 12.1164 14.4542 12.3341 14.6218 12.5055L14.6655 12.5491C14.8007 12.6842 14.908 12.8446 14.9812 13.0212C15.0544 13.1978 15.0921 13.387 15.0921 13.5782C15.0921 13.7693 15.0544 13.9586 14.9812 14.1352C14.908 14.3118 14.8007 14.4722 14.6655 14.6073C14.5304 14.7425 14.3699 14.8498 14.1934 14.923C14.0168 14.9962 13.8275 15.0339 13.6364 15.0339C13.4452 15.0339 13.2559 14.9962 13.0794 14.923C12.9028 14.8498 12.7424 14.7425 12.6073 14.6073L12.5636 14.5636C12.3922 14.396 12.1745 14.2835 11.9386 14.2407C11.7027 14.1979 11.4594 14.2268 11.24 14.3236C11.0249 14.4158 10.8414 14.5689 10.7122 14.764C10.583 14.9591 10.5137 15.1878 10.5127 15.4218V15.5455C10.5127 15.9312 10.3595 16.3012 10.0867 16.574C9.81392 16.8468 9.44395 17 9.05818 17C8.67241 17 8.30244 16.8468 8.02966 16.574C7.75688 16.3012 7.60364 15.9312 7.60364 15.5455V15.48C7.59801 15.2393 7.52009 15.0058 7.38001 14.81C7.23993 14.6141 7.04417 14.4649 6.81818 14.3818C6.59882 14.285 6.3555 14.2561 6.11957 14.2989C5.88365 14.3417 5.66595 14.4542 5.49455 14.6218L5.45091 14.6655C5.31582 14.8007 5.1554 14.908 4.97882 14.9812C4.80224 15.0544 4.61297 15.0921 4.42182 15.0921C4.23067 15.0921 4.04139 15.0544 3.86481 14.9812C3.68824 14.908 3.52782 14.8007 3.39273 14.6655C3.25749 14.5304 3.1502 14.3699 3.077 14.1934C3.00381 14.0168 2.96613 13.8275 2.96613 13.6364C2.96613 13.4452 3.00381 13.2559 3.077 13.0794C3.1502 12.9028 3.25749 12.7424 3.39273 12.6073L3.43636 12.5636C3.60403 12.3922 3.7165 12.1745 3.75928 11.9386C3.80205 11.7027 3.77317 11.4594 3.67636 11.24C3.58417 11.0249 3.43109 10.8414 3.23597 10.7122C3.04085 10.583 2.81221 10.5137 2.57818 10.5127H2.45455C2.06878 10.5127 1.69881 10.3595 1.42603 10.0867C1.15325 9.81392 1 9.44395 1 9.05818C1 8.67241 1.15325 8.30244 1.42603 8.02966C1.69881 7.75688 2.06878 7.60364 2.45455 7.60364H2.52C2.76072 7.59801 2.99419 7.52009 3.19004 7.38001C3.38589 7.23993 3.53507 7.04417 3.61818 6.81818C3.71499 6.59882 3.74387 6.3555 3.70109 6.11957C3.65832 5.88365 3.54585 5.66595 3.37818 5.49455L3.33455 5.45091C3.19931 5.31582 3.09202 5.1554 3.01882 4.97882C2.94562 4.80224 2.90795 4.61297 2.90795 4.42182C2.90795 4.23067 2.94562 4.04139 3.01882 3.86481C3.09202 3.68824 3.19931 3.52782 3.33455 3.39273C3.46963 3.25749 3.63005 3.1502 3.80663 3.077C3.98321 3.00381 4.17249 2.96613 4.36364 2.96613C4.55479 2.96613 4.74406 3.00381 4.92064 3.077C5.09722 3.1502 5.25764 3.25749 5.39273 3.39273L5.43636 3.43636C5.60777 3.60403 5.82547 3.7165 6.06139 3.75928C6.29731 3.80205 6.54064 3.77317 6.76 3.67636H6.81818C7.03329 3.58417 7.21674 3.43109 7.34596 3.23597C7.47518 3.04085 7.54452 2.81221 7.54545 2.57818V2.45455C7.54545 2.06878 7.6987 1.69881 7.97148 1.42603C8.24426 1.15325 8.61423 1 9 1C9.38577 1 9.75574 1.15325 10.0285 1.42603C10.3013 1.69881 10.4545 2.06878 10.4545 2.45455V2.52C10.4555 2.75403 10.5248 2.98267 10.654 3.17779C10.7833 3.37291 10.9667 3.52599 11.1818 3.61818C11.4012 3.71499 11.6445 3.74387 11.8804 3.70109C12.1164 3.65832 12.3341 3.54585 12.5055 3.37818L12.5491 3.33455C12.6842 3.19931 12.8446 3.09202 13.0212 3.01882C13.1978 2.94562 13.387 2.90795 13.5782 2.90795C13.7693 2.90795 13.9586 2.94562 14.1352 3.01882C14.3118 3.09202 14.4722 3.19931 14.6073 3.33455C14.7425 3.46963 14.8498 3.63005 14.923 3.80663C14.9962 3.98321 15.0339 4.17249 15.0339 4.36364C15.0339 4.55479 14.9962 4.74406 14.923 4.92064C14.8498 5.09722 14.7425 5.25764 14.6073 5.39273L14.5636 5.43636C14.396 5.60777 14.2835 5.82547 14.2407 6.06139C14.1979 6.29731 14.2268 6.54064 14.3236 6.76V6.81818C14.4158 7.03329 14.5689 7.21674 14.764 7.34596C14.9591 7.47518 15.1878 7.54452 15.4218 7.54545H15.5455C15.9312 7.54545 16.3012 7.6987 16.574 7.97148C16.8468 8.24426 17 8.61423 17 9C17 9.38577 16.8468 9.75574 16.574 10.0285C16.3012 10.3013 15.9312 10.4545 15.5455 10.4545H15.48C15.246 10.4555 15.0173 10.5248 14.8222 10.654C14.6271 10.7833 14.474 10.9667 14.3818 11.1818V11.1818Z"
      stroke="#78633A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ConnectionIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M17 14.6C17 15.0243 16.8314 15.4313 16.5314 15.7314C16.2313 16.0314 15.8243 16.2 15.4 16.2H2.6C2.17565 16.2 1.76869 16.0314 1.46863 15.7314C1.16857 15.4313 1 15.0243 1 14.6V3.39999C1 2.97564 1.16857 2.56868 1.46863 2.26862C1.76869 1.96856 2.17565 1.79999 2.6 1.79999H6.6L8.2 4.19999H15.4C15.8243 4.19999 16.2313 4.36856 16.5314 4.66862C16.8314 4.96867 17 5.37564 17 5.79999V14.6Z"
      stroke="#78633A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TasksIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        d="M9.75 1.25H2.75C2.28587 1.25 1.84075 1.43437 1.51256 1.76256C1.18437 2.09075 1 2.53587 1 3V17C1 17.4641 1.18437 17.9092 1.51256 18.2374C1.84075 18.5656 2.28587 18.75 2.75 18.75H13.25C13.7141 18.75 14.1592 18.5656 14.4874 18.2374C14.8156 17.9092 15 17.4641 15 17V6.5L9.75 1.25Z"
        stroke="#78633A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.75 1.25V6.5H15"
        stroke="#78633A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 10.875H4.5"
        stroke="#78633A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 14.375H4.5"
        stroke="#78633A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 7.375H5.375H4.5"
        stroke="#78633A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const TaskandReward = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        d="M3.4 13H2.6C2.17565 13 1.76869 12.8314 1.46863 12.5314C1.16857 12.2313 1 11.8243 1 11.4V3.39999C1 2.97564 1.16857 2.56868 1.46863 2.26862C1.76869 1.96856 2.17565 1.79999 2.6 1.79999H15.4C15.8243 1.79999 16.2313 1.96856 16.5314 2.26862C16.8314 2.56868 17 2.97564 17 3.39999V11.4C17 11.8243 16.8314 12.2313 16.5314 12.5314C16.2313 12.8314 15.8243 13 15.4 13H14.6"
        stroke="#78633A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.4L13 16.2H5L9 11.4Z"
        stroke="#78633A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const WalletIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        d="M6.43338 5.41784C6.58818 5.31464 6.77939 5.2224 7 5.15101L7.00001 6.84899C6.77939 6.7776 6.58818 6.68536 6.43338 6.58216C6.06927 6.33942 6 6.1139 6 6C6 5.8861 6.06927 5.66058 6.43338 5.41784Z"
        fill="#78633A"
      />
      <path
        d="M9.00002 10.849L9.00001 9.15101C9.22062 9.2224 9.41184 9.31464 9.56663 9.41784C9.93075 9.66058 10 9.8861 10 10C10 10.1139 9.93075 10.3394 9.56664 10.5822C9.41184 10.6854 9.22063 10.7776 9.00002 10.849Z"
        fill="#78633A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9 3C9 2.44772 8.55228 2 8 2C7.44772 2 7 2.44772 7 3V3.09199C6.3784 3.20873 5.80348 3.43407 5.32398 3.75374C4.6023 4.23485 4 5.00933 4 6C4 6.99067 4.6023 7.76515 5.32398 8.24626C5.80348 8.56593 6.37841 8.79128 7.00001 8.90801L7.00002 10.8492C6.60902 10.7223 6.31917 10.5319 6.15667 10.3446C5.79471 9.92748 5.16313 9.88274 4.74599 10.2447C4.32885 10.6067 4.28411 11.2382 4.64607 11.6554C5.20855 12.3036 6.05956 12.7308 7 12.9076L7 13C6.99999 13.5523 7.44769 14 7.99998 14C8.55226 14 8.99999 13.5523 9 13L9 12.908C9.62161 12.7913 10.1965 12.5659 10.676 12.2463C11.3977 11.7651 12 10.9907 12 10C12 9.00933 11.3977 8.23485 10.676 7.75373C10.1965 7.43407 9.6216 7.20873 9.00001 7.09199L9 5.15075C9.391 5.27771 9.68085 5.4681 9.84335 5.65538C10.2053 6.07252 10.8369 6.11726 11.254 5.7553C11.6712 5.39335 11.7159 4.76176 11.354 4.34462C10.7915 3.69637 9.94046 3.26915 9 3.09236V3Z"
        fill="#78633A"
      />
    </g>
  </svg>
);

export const GameCenterIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        d="M2.6 1.79999H15.4C15.8243 1.79999 16.2313 1.96856 16.5314 2.26862C16.8314 2.56868 17 2.97564 17 3.39999V8.19999C17 10.3217 16.1571 12.3566 14.6569 13.8568C13.1566 15.3571 11.1217 16.2 9 16.2C7.94943 16.2 6.90914 15.9931 5.93853 15.591C4.96793 15.189 4.08601 14.5997 3.34315 13.8568C1.84285 12.3566 1 10.3217 1 8.19999V3.39999C1 2.97564 1.16857 2.56868 1.46863 2.26862C1.76869 1.96856 2.17565 1.79999 2.6 1.79999V1.79999Z"
        stroke="#78633A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.7998 7.39996L8.9998 10.6L12.1998 7.39996"
        stroke="#78633A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const FolderIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M17 14.6C17 15.0243 16.8314 15.4313 16.5314 15.7314C16.2313 16.0314 15.8243 16.2 15.4 16.2H2.6C2.17565 16.2 1.76869 16.0314 1.46863 15.7314C1.16857 15.4313 1 15.0243 1 14.6V3.39999C1 2.97564 1.16857 2.56868 1.46863 2.26862C1.76869 1.96856 2.17565 1.79999 2.6 1.79999H6.6L8.2 4.19999H15.4C15.8243 4.19999 16.2313 4.36856 16.5314 4.66862C16.8314 4.96867 17 5.37564 17 5.79999V14.6Z"
      stroke="#78633A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SearchIcon = () => (
  <svg
    width="18"
    height="18"
    style={{ zIndex: 1 }}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.1111 15.2222C12.0385 15.2222 15.2222 12.0385 15.2222 8.1111C15.2222 4.18375 12.0385 1 8.1111 1C4.18375 1 1 4.18375 1 8.1111C1 12.0385 4.18375 15.2222 8.1111 15.2222Z"
      stroke="#18181B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 16.9999L13.1333 13.1332"
      stroke="#18181B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LocationIcon = () => (
  <svg
    width="9"
    height="12"
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.118164 4.96002C0.118164 2.68446 2.00806 0.835571 4.32499 0.835571C6.64193 0.835571 8.53182 2.68446 8.52273 4.96002C8.52273 5.25335 8.49548 5.54668 8.43187 5.83113C8.43187 5.84002 8.4296 5.8489 8.42733 5.85779C8.42506 5.86668 8.42279 5.87557 8.42279 5.88446C7.97757 7.79748 4.96584 10.6869 4.60942 11.0289C4.59487 11.0429 4.58475 11.0526 4.5794 11.0578C4.50671 11.12 4.41585 11.1556 4.32499 11.1556C4.23413 11.1556 4.14327 11.1289 4.07058 11.0578C3.93429 10.9333 0.672411 7.87557 0.209024 5.84002C0.209024 5.82534 0.206271 5.81335 0.203795 5.80257C0.201774 5.79378 0.199938 5.78578 0.199938 5.77779C0.145422 5.51113 0.118164 5.23557 0.118164 4.96002ZM7.70499 5.72446V5.69779C7.75951 5.45779 7.78677 5.2089 7.78677 4.95113C7.78677 3.07557 6.22397 1.55557 4.31591 1.55557C2.40784 1.55557 0.854132 3.08446 0.854132 4.95113C0.854132 5.18224 0.88139 5.41335 0.92682 5.64446C0.935906 5.66224 0.935906 5.67113 0.935906 5.6889C1.28117 7.20002 3.55268 9.5289 4.32499 10.2845C5.0973 9.5289 7.35972 7.20002 7.70499 5.72446Z"
      fill="#78633A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.9165 4.53336C2.9165 3.7778 3.54344 3.15558 4.32484 3.15558C5.10624 3.15558 5.73317 3.76891 5.73317 4.53336C5.73317 5.2978 5.09715 5.91113 4.32484 5.91113C3.55253 5.91113 2.9165 5.28891 2.9165 4.53336ZM3.65247 4.53336C3.65247 4.8978 3.95231 5.19113 4.32484 5.19113C4.69736 5.19113 4.9972 4.8978 4.9972 4.53336C4.9972 4.16891 4.69736 3.87558 4.32484 3.87558C3.95231 3.87558 3.65247 4.16891 3.65247 4.53336Z"
      fill="#78633A"
    />
  </svg>
);
export const ClockIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 8L7.66667 9.66667L11 6.33333M16 8C16 8.98491 15.806 9.96018 15.4291 10.8701C15.0522 11.7801 14.4997 12.6069 13.8033 13.3033C13.1069 13.9997 12.2801 14.5522 11.3701 14.9291C10.4602 15.306 9.48491 15.5 8.5 15.5C7.51509 15.5 6.53982 15.306 5.62987 14.9291C4.71993 14.5522 3.89314 13.9997 3.1967 13.3033C2.50026 12.6069 1.94781 11.7801 1.5709 10.8701C1.19399 9.96018 1 8.98491 1 8C1 6.01088 1.79018 4.10322 3.1967 2.6967C4.60322 1.29018 6.51088 0.5 8.5 0.5C10.4891 0.5 12.3968 1.29018 13.8033 2.6967C15.2098 4.10322 16 6.01088 16 8Z"
      stroke="#16A34A"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M12 2a7.008 7.008 0 0 0-7 7c0 5.353 6.036 11.45 6.293 11.707l.707.707.707-.707C12.964 20.45 19 14.353 19 9a7.008 7.008 0 0 0-7-7zm0 16.533C10.471 16.825 7 12.553 7 9a5 5 0 0 1 10 0c0 3.546-3.473 7.823-5 9.533z" />
    <path d="M12 6a3 3 0 1 0 3 3 3 3 0 0 0-3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" />
  </svg>
);
